var React = require('react');

function IconPlaybutton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"24","fill":"#2B2F35","key":0}),React.createElement("path",{"d":"M24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0ZM16 10.6667L16.1197 37.5406L39.2137 24.2073L16 10.6667Z","fill":"white","key":1})]);
}

IconPlaybutton.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IconPlaybutton;

IconPlaybutton.default = IconPlaybutton;
